import { useState } from "react";
import {
  LdIcon,
  LdInput,
  LdOption,
  LdSelect,
} from "@emdgroup-liquid/liquid/dist/react";

const Searchbar = () => {
  const [status, setStatus] = useState("all");
  return (
    <div className="flex flex-col md:flex-row justify-start w-full gap-ld-16">
      <LdInput
        className="flex-grow"
        size="sm"
        tone="dark"
        type="search"
        placeholder="Search..."
      >
        <LdIcon slot="start" name="magnifier" />
      </LdInput>
      <LdSelect
        size="sm"
        preventDeselection
        placeholder="Survey status"
        onInput={
          ((
            event: React.SyntheticEvent<HTMLInputElement, CustomEvent<string[]>>
          ) => {
            setStatus(event.nativeEvent.detail[0]);
          }) as unknown as any
        }
      >
        <LdOption selected={status === "all"} value="all">
          show all
        </LdOption>
        <LdOption selected={status === "active"} value="active">
          active
        </LdOption>
        <LdOption selected={status === "past"} value="past">
          past
        </LdOption>
      </LdSelect>
    </div>
  );
};

export default Searchbar;
